import React, { useState } from 'react'

// adapted from https://stackoverflow.com/questions/42036865/react-how-to-navigate-through-list-by-arrow-keys

const useKeyPress = (targetKey: any) => {
  const [keyPressed, setKeyPressed] = useState(false)

  function downHandler({ key }: any) {
    if (key === targetKey) {
      setKeyPressed(true)
    }
  }

  const upHandler = ({ key }: any) => {
    if (key === targetKey) {
      setKeyPressed(false)
    }
  }

  React.useEffect(() => {
    window.addEventListener('keydown', downHandler)
    window.addEventListener('keyup', upHandler)

    return () => {
      window.removeEventListener('keydown', downHandler)
      window.removeEventListener('keyup', upHandler)
    }
  })

  return keyPressed
}

export default useKeyPress
